export default {
    products: {
        loading: false,
        error: null,
        data: [],
    }
}


